/* eslint-disable max-len */

/**@deprecated */
export const STAND_WORKSHEET_REINITIALIZED_TOOLTIP_MESSAGE =
  'To initialize Stand Worksheet for a greyed out site, the Stand Worksheet setting must be enabled for this site in DM Site Preference.';
